import { useQuery } from '@tanstack/react-query';
import { clinicActionGetInvitationLink } from 'lib/api/firebase/apis/apis';
import { queryKeyFactory } from 'lib/utils/queryKeyFactory';

export function useGetInvitationLink(invitationId: string, enabled: boolean) {
  return useQuery({
    queryKey: queryKeyFactory.invitation.link(invitationId),
    queryFn: () => clinicActionGetInvitationLink({ invitationId }),
    enabled
  });
}
